import type { ContentItem, TabDefinition } from "../types";

export async function useContentChildrenTabNav ( parentPath: string ) {
  const { getChildren } = useContentDeliveryResource();
  const route = useRoute();

  const tabs = ref<TabDefinition[]>( [] );

  /**
   * Builds the list of tabs based on the content's children
   */
  async function fetchTabs (): Promise<void> {
    const children = await getChildren( parentPath, { sort: ["sortOrder:asc"] } );

    tabs.value = children?.data?.value?.items.map( ( c: ContentItem ) => ( {
      label: c.name,
      alias: c.name.replace( / /g, "-" ).toLowerCase(),
      to: c.route.path,
    } ) ) ?? [];
  }

  /**
   * Set the active tab alias based on where page route matches the tab route
   */
  const activeTabAlias = computed( () => {
    const activeTab = tabs?.value.find( ( t: TabDefinition ) => t.to === route.path );
    return activeTab?.alias;
  } );

  /**
   * Loads the tabs immediately as the component will not need to dynamically load the tabs
   */
  await fetchTabs();

  return {
    tabs,
    activeTabAlias,
  };
}
